/**
 * Mixin notyfikacji
 * Zawiera metody:
 *  - `notifySuccess(message)` - wyświetla powiadomienie o sukcesie
 *  - `notifyError(message)` - wyświetla powiadomienie o błędzie
 */
export const notificationsMixin = {
  methods: {
    /**
     * Wyświetla notyfikację o sukcesie
     *
     * @param {*} title
     * @param {*} messages
     */
    notifySuccess(title, messages) {
      this.$store.dispatch('notifySuccess', { title, messages });
    },

    /**
     * Wyświetla notyfikację o błędzie
     *
     * @param {*} title
     * @param {*} messages
     */
    notifyError(title, messages) {
      this.$store.dispatch('notifyError', { title, messages });
    },

    /**
     * Wyświetla modal z błędem
     *
     * @param {*} title
     * @param {*} messages
     */
    errorModal(title) {
      const description = `<div style="color:yellow; font-size: 36pt; font-weight: bold; position: absolute; top: -55px; left: -60px;">\u26A0</div><p style="font-size: 30pt;">${title}</p>`;
      this.$store.dispatch('setConfirm', {
        title: 'Operacja nieudana',
        description,
        submitButton: 'OK',
        showCloseButton: false
      });
    }
  }
};
